import BaseModel from "./BaseModel";
import { ChatContact } from "./ConversationModel";

export default class ConversationContactModel extends BaseModel {
  firstName: string;
  lastName: string;
  middleName: string;
  profilePictureUrl: string;

  constructor(data: any) {
    super(data);
    this.firstName = data.first_name!;
    this.lastName = data.last_name!;
    this.middleName = data.middle_name!;
    this.profilePictureUrl =
      data.profile_picture_url ??
      "https://upload.wikimedia.org/wikipedia/commons/4/47/HI_all.png";
  }

  get fullName(): string {
    return `${this.firstName} ${this.middleName} ${this.lastName}`;
  }

  get displayName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  static toChatContacts(contacts: ConversationContactModel[]): ChatContact[] {
    return contacts.map((contact) => {
      return {
        name: contact.displayName,
        badge: contact.object_type!,
        profilePictureUrl: contact.profilePictureUrl,
        unreadCount: 0,
        id: contact.id,
        userType: contact.object_type!,
      };
    });
  }
}
